import api from "@/utils/api";
import { Feedback } from "@/components/result/index.client";
import { isImageUrl } from "@/utils/isImageUrl";

export interface FeedbackRequest {
  feedback: Feedback;
  id: number;
}

export const verifyImage = async (imageFile: string | File) => {
  const data = new FormData();
  if (typeof imageFile === "string" && isImageUrl(imageFile)) {
    const response = await fetch(imageFile);
    const blob = await response.blob();
    const file = new File([blob], "image.jpg", { type: blob.type });
    data.append("file", file);
  } else {
    data.append("file", imageFile);
  }
  return await api.post(`/playground/driver-licenses`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const sendFeedback = async (data: FeedbackRequest) => {
  return await api.post(
    `/playground/driver-licenses/${data.id}/feedback`,
    data,
  );
};
